import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_Sortable, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_PertinentCategory } from './ModuleFE_PertinentCategory.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_PertinentCategory,
    modules: [ModuleFE_PertinentCategory],
    mapper: item => [item.label],
    placeholder: 'Choose a pertinent category',
    renderer: item => _jsxs(_Fragment, { children: [item.label, " "] })
};
export const DropDown_PertinentCategory = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_PertinentCategory,
    itemRenderer: (item, onDelete, disabled) => {
        return _jsxs(_Fragment, { children: [!disabled && _jsx(ICONS.x.component, { onClick: onDelete }), item?.label ?? 'Not Found'] });
    },
    uiSelector: DropDown_PertinentCategory.selectable,
});
export const MultiSelect_PertinentCategory = {
    editable: TS_MultiSelect_V2.prepare(Props_MultiSelect),
    sortable: TS_MultiSelect_Sortable.prepare(Props_MultiSelect),
};
//# sourceMappingURL=ui-components.js.map